import { toast, ToastPosition, Toast } from 'react-hot-toast';
import React from 'react';
import NotificationToast from '../common/NotificationToast';

interface ToastOptions {
    duration?: number;
    position?: ToastPosition
    // Add any other react-hot-toast options you want to support
}

const defaultOptions: ToastOptions = {
    duration: 5000,
    // position: 'top-right', // This will be set by the <Toaster/> globally
};

export const showToast = (
    title: string,
    message?: string,
    type: 'success' | 'error' | 'info' | 'warning' = 'info',
    options: ToastOptions = {}
) => {
    const toastOptions = { ...defaultOptions, ...options };
    
    // Using separate props object to avoid potential JSX attribute issues
    toast.custom((t) => {
        const toastProps = {
            t,
            title,
            message,
            type
        };
        return React.createElement(NotificationToast, toastProps);
    }, toastOptions);
};

export const showSuccessToast = (title: string, message?: string, options: ToastOptions = {}) => {
    showToast(title, message, 'success', options);
};

export const showErrorToast = (title: string, message?: string, options: ToastOptions = {}) => {
    showToast(title, message, 'error', options);
};

export const showInfoToast = (title: string, message?: string, options: ToastOptions = {}) => {
    showToast(title, message, 'info', options);
};

export const showWarningToast = (title: string, message?: string, options: ToastOptions = {}) => {
    showToast(title, message, 'warning', options);
};